import { useSalesServiceSalesOrdersRetrieve } from '@insurance/api/queries'
import { MissingCaseDocument } from '@insurance/api/requests'
import {
  DOCUMENT_CATEGORY_LABEL_KEY,
  ORDER_DOCUMENT_CATEGORIES
} from '@insurance/app-constants'
import { Alert, Flex, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'
import { OrderMediaActions } from '../OrderMediaActions'

export const GuaranteesMediaStep = () => {
  const { t } = useTranslation()
  const { orderKey } = formProps(t)

  const orderId = Form.useWatch<number | undefined>(orderKey.name, {
    preserve: true
  })

  const { data: order } = useSalesServiceSalesOrdersRetrieve(
    { id: Number(orderId) },
    undefined,
    { enabled: !!orderId }
  )

  const missingDocuments: MissingCaseDocument[] =
    order?.guarantees?.missing_documents || []

  return (
    <Flex vertical gap={12}>
      {!!missingDocuments.length && (
        <Alert
          type="warning"
          showIcon
          message={t('missing_case_documents')}
          description={
            <ul style={{ margin: 0, paddingLeft: 16 }}>
              {missingDocuments.map(({ category, label }) => (
                <li key={category + label}>{label}</li>
              ))}
            </ul>
          }
        />
      )}

      <OrderMediaActions
        orderId={orderId}
        categories={ORDER_DOCUMENT_CATEGORIES}
        categoryLabelKey={DOCUMENT_CATEGORY_LABEL_KEY}
      />
    </Flex>
  )
}
